import assert from 'assert-ts';
import type {Schemas} from 'api/dto.generated';
import type {MediasForEan} from '../types';
import {filterOnlyLatest, sortMedia, sortMediaAttachment} from '../functions';
import {mapMediaDto} from './mapMediaDto';

export const mapMediasForEans = (
  response: Schemas.MediaForEansDto,
): MediasForEan[] => {
  const mediaWithEan = (response ?? []).mediaForEans?.filter(
    m => m.ean,
  ) as Schemas.MediaForEanDto[];

  return mediaWithEan.map(mapMediaForEanDto);
};

export const mapMediaForEanDto = (
  dto: Schemas.MediaForEanDto,
): MediasForEan => {
  const media = dto.medias?.filter(m => !m.compressed).map(mapMediaDto) || [];
  const compressed =
    dto.medias?.filter(m => m.compressed).map(mapMediaDto) || [];

  const latest = filterOnlyLatest(media)
    .sort(sortMedia)
    .sort(sortMediaAttachment);

  const latestCompressed = filterOnlyLatest(compressed)
    .sort(sortMedia)
    .sort(sortMediaAttachment);

  return {
    ean: assert(dto.ean, 'mapMediaForEanDto: Expected ean', dto),
    medias: [...latest, ...latestCompressed],
  };
};
